export default "__VITE_ASSET__XSTiMgFd__"